<template>
  <div>
    <div class="mb-0.5 w-full text-left text-xs">
      {{ name }}
    </div>
    <vue-date-range-picker
      :ref="props.name"
      v-model="dateVal"
      :min-date="min"
      :max-date="max"
      :disabled="disabled"
      :opens="opens"
      :locale-data="props.localeData || localeDataSet"
      :ranges="props.showRanges && (ranges || defaultRanges)"
      :close-on-esc="true"
      :single-date-picker="singleDatePicker"
      :time-picker="props.timePicker"
      :append-to-body="appendToBody"
      @update="updateVal"
    >
      <template #input>
        <div
          class="flex items-center justify-between fill-cdp-black-500 text-cdp-black-500"
          :class="{
            'fill-cdp-grey-400 text-cdp-grey-400': props.disabled
          }"
        >
          <icon v-if="props.icon" name="icon-calender" class="mr-2 h-4 w-4" />
          <div v-show="singleDatePicker" class="title text-sm">
            <span class="mr-2">{{
              dayjs(props.modelValue).format(
                props.timePicker ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
              )
            }}</span>
          </div>
          <div v-show="!singleDatePicker" class="title text-sm">
            <span class="mr-2">{{
              dayjs(props.modelValue[0]).format(
                props.timePicker ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
              )
            }}</span>
            -
            <span class="ml-2">{{
              dayjs(props.modelValue[1]).format(
                props.timePicker ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
              )
            }}</span>
          </div>
          <icon name="ic_common_arrow01_down" class="ml-1.5 mt-0.5 h-4 w-4" />
        </div>
      </template>
    </vue-date-range-picker>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import vueDateRangePicker from 'daterange-picker-vue3';
import 'daterange-picker-vue3/dist/daterange-picker-vue3.css';

import dayjs from '@/plugins/dayjs';

import { defineComponent, computed } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'DateRange',
  components: {
    vueDateRangePicker
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Array, String],
      require: true,
      default: () => {
        return [
          String, // startDate
          String // endDate
        ];
      }
    },
    localeData: {
      type: Object,
      default: () => {}
    },
    ranges: {
      type: Object,
      default: () => {}
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    opens: {
      type: String,
      default: 'center'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    singleDatePicker: {
      type: Boolean,
      default: false
    },
    timePicker: {
      type: Boolean,
      default: false
    },
    showRanges: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const { t } = useI18n();

    let today = dayjs(new Date()).toDate();
    let yesterday = dayjs(new Date()).toDate();
    yesterday.setDate(today.getDate() - 5);

    const localeDataSet = {
      direction: 'ltr',
      format: 'yyyy-mm-dd',
      separator: ' - ',
      applyLabel: t('confirm'),
      cancelLabel: t('cancel'),
      weekLabel: 'W',
      customRangeLabel: '',
      daysOfWeek: [
        t('sunday'),
        t('monday'),
        t('tuesday'),
        t('wednesday'),
        t('thursday'),
        t('friday'),
        t('saturday')
      ],
      monthNames: [
        t('january'),
        t('february'),
        t('march'),
        t('april'),
        t('may'),
        t('june'),
        t('july'),
        t('august'),
        t('september'),
        t('october'),
        t('november'),
        t('december')
      ],
      firstDay: 0
    };

    const dateVal = computed({
      get: () => {
        if (props.singleDatePicker) {
          return {
            startDate: props.modelValue,
            endDate: props.modelValue
          };
        } else {
          return {
            startDate: props.modelValue[0],
            endDate: props.modelValue[1]
          };
        }
      }
    });

    function updateVal(val) {
      let result = null;
      if (props.singleDatePicker) {
        result = dayjs(val.startDate).format();
      } else {
        result = [dayjs(val.startDate).format(), dayjs(val.endDate).format()];
      }
      emit('update:modelValue', result);
      emit('change', result);
    }

    return {
      props,
      dayjs,
      localeDataSet,
      defaultRanges: {
        今日: [today, today]
      },
      dateVal,
      updateVal
    };
  }
});
</script>